'use strict';

angular.module('msWidgets').directive('msWidgetInputCheckBoxes', [function () {
  return {
    templateUrl: 'widgets/templates/input/check_boxes.html'
  };
}]).directive('msWidgetInputDropDown', [function () {
  return {
    templateUrl: 'widgets/templates/input/drop_down.html'
  };
}]).directive('msWidgetInputSlider', [function () {
  return {
    templateUrl: 'widgets/templates/input/slider.html'
  };
}]).directive('msWidgetInputTextArea', [function () {
  return {
    templateUrl: 'widgets/templates/input/text_area.html'
  };
}]).directive('msWidgetInputTextInput', [function () {
  return {
    templateUrl: 'widgets/templates/input/text_input.html'
  };
}]).directive('msWidgetInputUserResponse', [function () {
  return {
    templateUrl: 'widgets/templates/input/user_response.html'
  };
}]);